import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bool, any, string, object, shape } from 'prop-types';

import { appConfig } from 'config/customization';
import { ROUTES } from 'constants/routes';
import { accountPropTypes } from 'redux/accountHandlers';

import Dashboard from './layout';
import AlertsBar from './components/AlertsBar';

class DashboardContainer extends PureComponent {
  state = { alertHeight: 0 };

  handleUpdateAlertSize = alertHeight => this.setState({ alertHeight });

  render() {
    const {
      accountsLoading,
      addAccountsInProgress,
      history,
      displayAdvice,
      location,
      currentAccount
    } = this.props;
    const inClientSummary = location.pathname === ROUTES.CLIENT_SUMMARY;
    const inMyAccounts = location.pathname === ROUTES.ACCOUNTS;
    return (
      <Fragment>
        {appConfig.accountAlerts.active && currentAccount && (
          <AlertsBar handleUpdateAlertSize={this.handleUpdateAlertSize} />
        )}
        <Dashboard
          loadingAuth={accountsLoading && !addAccountsInProgress && !inClientSummary && !inMyAccounts}
          location={history.location}
          displayAdvice={displayAdvice && appConfig.withAppDownloader}
          alertHeight={this.state.alertHeight}
          currentAccount={currentAccount}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = store => ({
  accountsLoading: store.account.accountsLoading,
  addAccountsInProgress: store.account.addAccountFlow && store.account.addAccountFlow.inProgress,
  displayAdvice: store.device.isMobile && !store.device.adviceSubmitted,
  currentAccount: store.account.currentAccount
});

DashboardContainer.propTypes = {
  location: shape({
    pathname: string.isRequired,
    state: object,
    search: string
  }),
  addAccountsInProgress: bool.isRequired,
  accountsLoading: bool.isRequired,
  history: any, // eslint-disable-line react/forbid-prop-types
  displayAdvice: bool,
  currentAccount: accountPropTypes
};

export default connect(mapStateToProps)(DashboardContainer);
